import { queryKeys } from "@/lib/queryClient";
import { fetchUserSubscriptionState } from "@/services/userSubscriptionState.service";
import type { UserSubscriptionStateRow } from "@/types/userSubscriptionState";
import { useQuery } from "@tanstack/react-query";

const STALE_MS = 60 * 1000;

export function useUserSubscriptionState(opts: {
  userId: string | undefined;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: queryKeys.subscriptionState(opts.userId),
    queryFn: async (): Promise<UserSubscriptionStateRow | null> => {
      return fetchUserSubscriptionState();
    },
    enabled: Boolean(opts.enabled !== false && opts.userId),
    staleTime: STALE_MS,
  });
}
